import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '@/core/theme/theme';
import RootErrorPage from '@/components/Error/RootErrorPage';
import Button from '@/components/Button/Button';
import tokens from '@/core/tokens.json';

interface MinimalAppWithErrorProps {
  title?: string;
  description?: string;
  cta?: React.ReactNode;
}

function MinimalAppWithError(props: MinimalAppWithErrorProps) {
  const title = props.title ?? tokens['WRONG'];
  const description = props.description ?? tokens['TRY_AGAIN'];

  const CTA = props.cta ?? (
    <Button variant="contained" onClick={() => location.reload()}>
      {tokens.TRY}
    </Button>
  );

  return (
    <ThemeProvider theme={theme}>
      <RootErrorPage title={title} description={description} cta={CTA} />
    </ThemeProvider>
  );
}

export default MinimalAppWithError;
